import showAlert from "../server/ShowAlert";
import { showAlertWithConfirm } from "../server/ShowAlert";

export const EMPTY_CART_MESSAGE =
  "לא ניתן להמשיך לתשלום — העגלה ריקה. הוסיפו פריטים לעגלה כדי להמשיך.";

export const getActiveCartItems = (productsInCart = []) =>
  productsInCart.filter((item) => Number(item.quantity) > 0);

export const hasActiveCartItems = (productsInCart = []) =>
  getActiveCartItems(productsInCart).length > 0;

export const warnEmptyCart = () =>
  showAlert({ msgTitle: EMPTY_CART_MESSAGE, msgType: "warning" });

/** Warn about out-of-stock lines still in the cart (does not block checkout). */
export const warnOutOfStockCartItems = (productsInCart = []) => {
  const outOfStock = productsInCart.filter((product) => product.quantity === 0);
  if (!outOfStock.length) return;

  const itemNames = outOfStock
    .map((item) => item.product?.name || "")
    .join("<br>");
  showAlertWithConfirm({
    msgHtml: `<div class="missing-items-alert">שים לב אלו הפריטים שאזלו מן המלאי: <div class="missing-items-container">
                <strong>${itemNames}</strong></div></div>`,
  });
};

/**
 * Returns true when checkout navigation may proceed; shows alerts otherwise.
 */
export const canProceedToCheckout = (productsInCart = []) => {
  if (!hasActiveCartItems(productsInCart)) {
    warnEmptyCart();
    return false;
  }
  warnOutOfStockCartItems(productsInCart);
  return true;
};
